import * as React from "react";

import { useAuditIdentityOptions } from "@/shared/components/principal";
import { type FilterDefinition } from "@/shared/components/ResourceView";
import {
  hydrateFilterDefinitions,
  SESSION_CORE_FILTER_FIELDS,
} from "@/shared/components/ResourceView/Filters/catalog";

export {
  sessionDatasetIdFilter,
  sessionDeviceIdFilter,
} from "@/shared/components/ResourceView/Filters/catalog";

/**
 * Filterable Sessions fields common to every Sessions list mount. Mounts
 * compose their picker by spreading the array this hook returns and appending
 * the cross-aggregate id rows their scope admits: `sessionDatasetIdFilter`,
 * `sessionDeviceIdFilter`, or both.
 *
 * A hook (not a static const) because the `created_by` / `modified_by`
 * identity filters need org-scoped directories — see
 * {@link useAuditIdentityOptions}. The rows themselves live in the shared
 * filter catalog, where the chat's View tools read them too.
 */
export function useCoreSessionFilters(
  orgId: string | undefined,
): FilterDefinition[] {
  const identityOptions = useAuditIdentityOptions(orgId);

  return React.useMemo(
    () =>
      hydrateFilterDefinitions(SESSION_CORE_FILTER_FIELDS, { identityOptions }),
    [identityOptions],
  );
}
